export default class SolrSort {
  private fieldName: string;
  private order: string;

  private constructor({ fieldName, order }: { fieldName: string; order: 'asc' | 'desc' }) {
    this.fieldName = fieldName;
    this.order = order;
  }

  public static articleDate(sortOption?: SortOptions): SolrSort {
    return new SolrSort({
      fieldName: 'articleDate_dt',
      order: sortOption?.order ?? 'desc',
    });
  }

  /** should only be used in SolrQuery */
  public setUrlParams(url: URL): void {
    url.searchParams.set('sort', `${this.fieldName} ${this.order}`);
  }
}

interface SortOptions {
  order: 'asc' | 'desc';
}
